import React from 'react'
import FactsData from '../../factsData.json'
import Button from '../Button'
import ModalFactContent from '../ModalFactContent'

import './style.scss'

class ModalFact extends React.Component {
  constructor(props) {
    super(props);

    this.tags = FactsData.tags
    this.data = this.getFactData(this.props.index)
    this.nextFact = this.nextFact.bind(this)

    this.state = {
      addNewModalContent: false,
      isBackButtonClicked: false
    }
  }

  componentDidMount() {
    this.modal = document.querySelector('.modal')
    this.elementReload = this.modal.querySelector('.reload')
    this.elementReload.addEventListener('click', this.nextFact);

    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', this.onBackButtonEvent);
  }

  componentWillUnmount = () => {
    window.removeEventListener('popstate', this.onBackButtonEvent);
  }

  onBackButtonEvent = (e) => {
    e.preventDefault();
    if (!this.isBackButtonClicked) {

      this.isBackButtonClicked = true

      this.data = this.getFactData(this.prevData.id)
      window.history.pushState('', '', window.location.origin + window.location.pathname + '#' + this.data.id)

      this.setState({
        addNewModalContent: true
      })

      this.modal.classList.add('prev')
      this.elementReload.classList.add('disabled')

      setTimeout(() => {
        this.modal.classList.remove('prev')
        this.elementReload.classList.remove('disabled')

        this.setState({
          addNewModalContent: false
        })
        this.isBackButtonClicked = false
      }, 1750)
    }
  }

  getFactData(id) {
    this.data = FactsData.data.filter(
      function(data) {
        return data.id === parseInt(id)
      }
    )

    this.data[0].tagName = this.tags.filter((obj) => {
      return obj.id === this.data[0].tag
    })[0].name

    return this.data[0]
  }

  randomNumber() {
    const min = 1
    const max = 160
    return  min + Math.floor((max - min) * Math.random())
  }

  nextFact() {
    this.prevData = this.data
    this.data = this.getFactData(this.randomNumber())
    window.history.pushState('', '', window.location.origin + window.location.pathname + '#' + this.data.id)

    this.setState({
      addNewModalContent: true
    })

    this.modal.classList.add('next')
    this.elementReload.classList.add('disabled')

    setTimeout(() => {
      this.modal.classList.remove('next')
      this.elementReload.classList.remove('disabled')

      this.setState({
        addNewModalContent: false
      })
    }, 1750)
  }

  render() {
    return (
      <>
        <ModalFactContent
          {...this.props}
          {...this.state}
          data={this.data}
        />
        {
          this.state.addNewModalContent ? <ModalFactContent data={this.prevData}/> : ''
        }

        <span className="reload-wrapper">
          <Button title={'Другой факт'} withIcon={'reload'}/>
        </span>
      </>
    )
  }
}

export default ModalFact
